export default {
  REMOVE_ITEM: 'remove_item',
  OUT_OF_STOCK_ITEM: 'out_of_stock_item',
};
